import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './index.scss';
import { ToastContainer } from 'react-toastify';
import { allNotifications } from '../../utils/toastify';

import { ContainedLoader } from '../../components/Loader';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import Header from '../../components/Header';
import NewPlan from '../../components/NewPlan';
import ModalBox from '../../components/ModalBox';
import Search from '../../components/Search';
import CardBoxTreatmentPlan from '../../components/CardBoxTreatmentPlan';
import services from '../../services/services';
import UserAvatarEleg from '../../components/UserAvatarEleg';

const { notifyErrorBottomRight } = allNotifications;

class PacientList extends Component {
  constructor(props) {
    super(props);

    this.iScroll = React.createRef();
    this.state = {
      linkParams: props.location.state,
      valueSearch: '',
      loadingScreen: true,
      error: false,
      listPatients: []
    };
  }

  loadItemsME = filtro => {
    if (this.state.linkParams && this.state.linkParams.add) {
      services
        .mobileengine('buscarPacientes', {
          codigoPrestador: this.props.creden,
          filtro
        })
        .then(response => {
          this.setState({ listPatients: response });
        })
        .catch(err => {
          this.notify(err.message);
        })
        .finally(() => this.setState({ loadingScreen: false }));
    } else {
      services
        .mobileengine('buscarPacientes', {
          codigoPrestador: this.props.creden,
          status_gto: 'NAOFATURADA',
          filtro
        })
        .then(response => {
          this.setState({ listPatients: response });
        })
        .catch(err => {
          this.notify(err.message);
        })
        .finally(() => this.setState({ loadingScreen: false }));
    }
  };

  toggleCreate = () => {
    this.iScroll.current.scrollTo(0, 0);
    this.setState(state => ({ modalActive: !state.modalActive }));
  };

  handleChangeSearch = e => {
    const limitToSearch = 5;
    const { value } = e.target;

    const isSmaller = value.length < limitToSearch;

    this.setState(
      {
        valueSearch: value
      },
      () => {
        if (!isSmaller) {
          this.loadItemsME(value);
        } else if (value === '') {
          this.loadItemsME();
        }
      }
    );
  };

  changeIconOut = async () => {
    await this.setState({ valueSearch: '' });
    this.loadItemsME();
  };

  notify = message => notifyErrorBottomRight(message);

  componentDidMount = () => {
    this.loadItemsME();
  };

  render() {
    const { valueSearch, linkParams, listPatients } = this.state;

    return (
      <Fragment>
        <ToastContainer />
        <Header class="title-center orange-gradient" name={linkParams.title} />

        <div className="row">
          <UserAvatarEleg bgClass="UserAvatar" />
        </div>

        <div className="PacientList" ref={this.iScroll}>
          <Search
            placeholder="Busque aqui o nome ou carteirinha do paciente"
            valueSearch={valueSearch}
            handleChange={e => this.handleChangeSearch(e)}
            changeIconOut={this.changeIconOut}
          />

          {this.state.loadingScreen && <ContainedLoader />}

          {!this.state.loadingScreen && !this.state.error && (
            <Fragment>
              {listPatients.length > 0 && !this.state.modalActive ? (
                <>
                  <p className="selectPac">
                    {linkParams.add
                      ? 'Selecione um paciente para solicitar ou consultar as GTOs.'
                      : 'Nessa lista aparece somente os pacientes com GTOs solicitadas e não faturadas.'}
                  </p>
                  {listPatients.map(patient => (
                    <CardBoxTreatmentPlan key={patient.id} data={patient} allowSeeDetails />
                  ))}
                </>
              ) : (
                  <div>
                    <p className="NotFoundPac">Paciente não encontrado. Deseja adicionar?</p>
                    <button className="addNewPac" type="button" onClick={this.toggleCreate}>
                      Adicionar novo paciente
                  </button>
                  </div>
                )}

              {linkParams.add && (
                <Tooltip title="Novo paciente">
                  <Fab
                    className="btn-adicionar"
                    color="primary"
                    aria-label="add"
                    onClick={() => this.toggleCreate()}
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
              )}
            </Fragment>
          )}

          {this.state.error && (
            <div className="boxEmpty">
              <div className="empty" />
              <p>Não foi possível carregar a lista de pacientes</p>
            </div>
          )}
        </div>

        <ModalBox
          modalActive={this.state.modalActive}
          modalLabel="Adicionar Novo Paciente"
          onChange={this.toggleCreate}
        >
          <NewPlan />
        </ModalBox>
      </Fragment>
    );
  }
}

PacientList.propTypes = {
  creden: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  creden: state.login.user.codigo
});

export default connect(mapStateToProps)(PacientList);
